export const rootColor = "#141b2b"; //mainBackground-color
export const rootColorDark = "#0e1118";
export const secondaryColor = "#f1f1f1"; //primary text-color

export const rootColorLight = "#314166";

export const totalCasesColor = "#74a1ab";
export const totaldeathsColor = "#b30000";
export const totalRecoveredColor = "#0fb77f";
export const totalActiveColor = "#a2682c";
export const totalTestsColor = "#57b9aa";
export const totalNewDeaths = "#DD1155";
export const totalNewCases = "#FF5A5F";
export const totalCriticalCases = "#97D2FB";
